module.exports = __webpack_public_path__ + "static/media/logotype-square-grayscale.9c36b864.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/univermag/logotype-square-grayscale.png
// module id = 989
// module chunks = 124